import * as React from "react";

function SvgStraight1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M-10 210h1620V105.2H-10z" /></svg>;
}

export default SvgStraight1;